
import { Form, Formik } from 'formik'
import {
  Box,
  Typography,
  Button
} from '@material-ui/core';

import {
  Apartment,
  Person,
  Lock,
} from '@material-ui/icons';

import radinfoLogo from '../../shared/assets/images/radinfo-logo.svg';
import roadmap from '../../shared/assets/images/roadmap.svg';
import { MD5 } from 'crypto-js';
import Input from '../../shared/components/input';
import { useLoginStyles } from './style';
import { criarAlerta, obterMensagemApiException } from '../../shared/functions';
import { useGlobalContext } from '../../shared/hooks';
import { TSeverityNotificacao } from '../../shared/interfaces';
import { SolicitacaoDeSenhaService } from '../../shared/services';
import { Loading, Notificacao } from '../../shared/components';
import { useEffect } from 'react';
import { configs } from '../../shared/configs';

interface IFormValues {
  codFunc: string
  senha: string
  codCliente: string
}

const initialValues: IFormValues = {
  codCliente: '',
  senha: '',
  codFunc: '',
}

export const Login = () => {
  const classes = useLoginStyles();

  const {
    setLoading,
    setNotificacao
  } = useGlobalContext();

  const notificar = async (severity: TSeverityNotificacao, message: string) =>
      await criarAlerta(severity, message, setNotificacao);
  
  const handleSubmit = async (values: IFormValues) => {
    try {
      setLoading(true);
      if (!values.codCliente || values.codCliente === '')
        return notificar(
            'warning',
            'Informe o código de cliente RAD!',
        );

      if (!values.codFunc || values.codFunc === '')
        return notificar(
          'warning',
          'Informe seu código de funcionário!',
        );

      if (!values.senha || values.senha === '')
        return notificar(
          'warning',
          'Informe sua senha!',
        );

      const mD5_Senha = MD5(values.senha).toString().toUpperCase();

      const token = await SolicitacaoDeSenhaService.GerarToken({
          codCliente: Number(values.codCliente),
          codFunc: Number(values.codFunc),
          mD5_SENHA: mD5_Senha
      });

      window.location.protocol.includes("https")
        ? window.location.href = `https://${window.location.hostname}${configs.BASENAME}?token=${token}`
        : window.location.href = `http://${window.location.hostname}:${window.location.port}${configs.BASENAME}?token=${token}`;
    }
    catch (error) {
      notificar(
        'error',
        obterMensagemApiException(error),
      );
    }
    finally{
      setLoading(false);
    }
  }

  useEffect(
    () => {
      setLoading(false);
    }
    ,[]
  );

  return (
    <Box
      display="flex"
      alignItems="center"
      height="100vh"
      className={classes.mainContainer}
    >
      <Loading />

      <Notificacao />

      <Box
        height="100%"
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Box className={classes.formContainer}>
          <Typography className={classes.titleLeft} component="h1">
            Entrar
          </Typography>
          <Box my={2}>
            <Typography className={classes.text} color="primary">
              Efetue o login para visualizar suas solicitações de senha
            </Typography>
            <div className={classes.line}></div>
          </Box>

          <Formik initialValues={initialValues} onSubmit={handleSubmit}>
              <Form>
                <Input
                  label="Empresa"
                  name="codCliente"
                  type="text"
                  required
                  icon={<Apartment className={classes.icon} />}
                />

                <Input
                  label="Usuário"
                  name="codFunc"
                  type="number"
                  required
                  icon={<Person className={classes.icon} />}
                />

                <Input
                  label="Senha"
                  name="senha"
                  type="password"
                  required
                  icon={<Lock className={classes.icon} />}
                />

                <Button
                  type="submit"
                  disableRipple={false}
                  variant="contained"
                  className={classes.button}
                >
                  Acessar
                </Button>
              </Form>
          </Formik>
        </Box>
      </Box>

      {/* ----------------------------------------------- Direita ------------------- */}
      <Box
        maxWidth={1 / 2}
        width={"100%"}
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
        flexDirection="column"
        height="100%"
        className={classes.root}
      >
        <img src={radinfoLogo} width={150} alt="Radinfo Logo" />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
        >
          <Box
            className={classes.subTitle}
            maxWidth={400}
            my={0}
            fontSize={20}
            fontWeight="fontWeightLight"
            component="p"
            textAlign="center"
          >
            Aplicação de liberação de senhas
          </Box>
        </Box>
        <img src={roadmap} alt="Imagem promocional" />
      </Box>
    </Box>
  )
}